/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewLocale } from './CRSFSecReviewLocale';
import {
    CRSFSecReviewLocaleFromJSON,
    CRSFSecReviewLocaleFromJSONTyped,
    CRSFSecReviewLocaleToJSON,
} from './CRSFSecReviewLocale';

/**
 * Request payload for CRA scans.
 * @export
 * @interface CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
 */
export interface CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    account_line_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    agency_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    cobranded?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    desired_policy_uuid?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    external_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    force?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {CRSFSecReviewLocale}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    locale?: CRSFSecReviewLocale;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    metrics?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    renewal_of_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger
     */
    retained_from_uuid?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger interface.
 */
export function instanceOfCRSFSecReviewSrcHttpdlibCoreModelsCraTrigger(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;

    return isInstance;
}

export function CRSFSecReviewSrcHttpdlibCoreModelsCraTriggerFromJSON(json: any): CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger {
    return CRSFSecReviewSrcHttpdlibCoreModelsCraTriggerFromJSONTyped(json, false);
}

export function CRSFSecReviewSrcHttpdlibCoreModelsCraTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_line_uuid': !exists(json, 'account_line_uuid') ? undefined : json['account_line_uuid'],
        'agency_name': !exists(json, 'agency_name') ? undefined : json['agency_name'],
        'cobranded': !exists(json, 'cobranded') ? undefined : json['cobranded'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'desired_policy_uuid': !exists(json, 'desired_policy_uuid') ? undefined : json['desired_policy_uuid'],
        'domains': json['domains'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'locale': !exists(json, 'locale') ? undefined : CRSFSecReviewLocaleFromJSON(json['locale']),
        'metrics': !exists(json, 'metrics') ? undefined : json['metrics'],
        'renewal_of_id': !exists(json, 'renewal_of_id') ? undefined : json['renewal_of_id'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'retained_from_uuid': !exists(json, 'retained_from_uuid') ? undefined : json['retained_from_uuid'],
    };
}

export function CRSFSecReviewSrcHttpdlibCoreModelsCraTriggerToJSON(value?: CRSFSecReviewSrcHttpdlibCoreModelsCraTrigger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_line_uuid': value.account_line_uuid,
        'agency_name': value.agency_name,
        'cobranded': value.cobranded,
        'currency': value.currency,
        'desired_policy_uuid': value.desired_policy_uuid,
        'domains': value.domains,
        'entity_name': value.entity_name,
        'external_id': value.external_id,
        'force': value.force,
        'ip_addresses': value.ip_addresses,
        'locale': CRSFSecReviewLocaleToJSON(value.locale),
        'metrics': value.metrics,
        'renewal_of_id': value.renewal_of_id,
        'request_origin': value.request_origin,
        'retained_from_uuid': value.retained_from_uuid,
    };
}

